import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewChild, OnChanges, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { HttpService } from '../../services';
@Component({
  selector: 'app-mat-table',
  templateUrl: './mat-table.component.html',
  styleUrls: ['./mat-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatTableComponent implements OnChanges, OnInit {

  @Input() columns;
  @Input() loading = false;
  @Input() isSelectAllEnabled = true;
  @Input() disableSelect?: string;
  @Input() select?: string;
  @Input() pagination = true;
  @Input() dataSource;
  @Input() total: number;
  @Input() disableValue;
  @Input() colorKey; // for colored rows;
  @Input() checkKeyForDisable?: string;
  @Output() fetchData = new EventEmitter();
  @Output() selected = new EventEmitter<any>();
  @Output() rowAction = new EventEmitter<{ action: string, row }>();
  @Output() incDec = new EventEmitter<{ type: string, row }>();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  tableData = new MatTableDataSource();
  limit = 10;
  page = 0;
  pageIndex = 0;
  pageLimit = [10, 20, 50, 100];

  displayedColumns = [];

  selection = new SelectionModel();

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.tableData.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.tableData.data.forEach(row => this.selection.select(row));
    this.selected.emit(this.selection.selected);
  }

  refresh(event) {
    if (event.pageSize !== this.limit) {
      this.limit = event.pageSize;
      this.page = event.pageIndex;
      this.fetchData.emit(this.getPagination());
    } else {
      if (this.total > this.tableData.data.length) {
        this.page = event.pageIndex;
        this.fetchData.emit(this.getPagination());
      }
    }
    this.selection.clear();
    this.selected.emit(this.selection.selected);
  }

  getPagination() {
    return {
      limit: this.limit,
      offset: (this.page * this.paginator.pageSize),
    };
  }

  selectRow(row) {
    this.selection.select(row);
    this.selected.emit(this.selection.selected);
  }
  selectionChanged(row, col?) {
    if (this.select && !(col?.incDec || col?.colKey === 'action') &&
      (this.disableSelect ? row[this.disableSelect] >= 1 : true)) {
      this.selection.toggle(row);
      this.selected.emit(this.selection.selected);
    }
  }

  triggerAction(action: string, row) {
    this.resetSelection();
    this.rowAction.emit({ action, row });
  }

  triggerIncDec(type: string, row) {
    this.resetSelection();
    this.incDec.emit({ type, row });
  }

  constructor(public http: HttpService) { }

  resetSelection() {
    this.selection.clear();
    this.selected.emit(this.selection);
  }

  ngOnInit() {
    this.fetchData.emit({ limit: 10, offset: 0 });
  }
  ngOnChanges() {
    this.displayedColumns = this.columns.map(col => col.colKey);
    if (this.select) {
      this.displayedColumns = ['select', ...this.displayedColumns];
      if (this.select === 'multiple') {
        this.selection = new SelectionModel(true, []);
      } else {
        this.selection = new SelectionModel(false, []);
      }
    }
    this.tableData = new MatTableDataSource(this.dataSource);
  }
  getProfileImage(item) {
    return item.genderName !== undefined ? item.gender === 1 ? 'assets/male.png' :
      item.gender === 2 || item.gender === 3 ? 'assets/female.png' : 'assets/default-profile.png'
      : 'assets/main/default-profile.png';
  }
}
